// extracted by mini-css-extract-plugin
module.exports = {"tablet-landscape-up":"(min-width: calc(1024 * 1px))","title":"FriendsRequest_title__21R6f","titleAction":"FriendsRequest_titleAction__3d2lB"};